import { usePoMutation, zahajAutorizaci } from '@gov-nx/api';

interface ZahajAutorizaciQueryProps {
	onSuccess?: (data: Awaited<ReturnType<typeof zahajAutorizaci>>) => void;
}

export const useZahajAutorizaciQuery = (props?: ZahajAutorizaciQueryProps) => {
	const mutation = usePoMutation(
		{
			mutationFn: zahajAutorizaci,
			onSuccess: (data) => {
				props?.onSuccess?.(data);
			},
		},
		{
			errorIgnoreFilter: () => true,
		}
	);

	return mutation;
};
